<template>


  <div class="wrapper" id="beranda" v-if="!isExpired">
    <!--
    <div v-if="waBotReady == true" class="whatsapp" style="
    position:fixed;
    z-index:9999;
    background-color:#2ecc71;
    right: 0;
    bottom: 0;
    margin: 20px;
    padding: 10px 20px;
    border-radius: 20px;
    "
    >
      <span class="text-white"> WA BOT Siap digunakan</span>
    </div>
    <div v-else-if="waBotReady == false" class="whatsapp" style="
    position:fixed;
    z-index:9999;
    background-color:#e67e22;
    right: 0;
    bottom: 0;
    margin: 20px 20px 50px 20px;
    padding: 10px 20px;
    border-radius: 20px;
    "
    >
      <span class="text-white"> Menghubungkan ke WA BOT... Jika lama scan ulang aja yakk</span>
    </div>
    -->
    <div class="sidebar" data-color="green" data-background-color="white" data-image="../img/sidebar-1.jpg" v-show="loginStat"  v-bind:class="{'mobile' : navOpen}"   @click="menuPopup = false">
      <div class="logo text-center" style="background-color:#2c3e50;">
        <div style="width:100px;height:100px;overflow:hidden;border-radius:100px;margin:0 auto;display:flex;">
          <img style="width:100px;align-self:center;" :src="'https://akulelah.web.id/assets/images/'+logo" alt="logo" /> <!-- https://blonjo.web.id/beat/API/WIFI/images/ -->
        </div>
        <span class="simple-text logo-normal text-white">
          <div v-show="isCS">
            <small class="d-block">CS - {{CSNama}}</small>
            <small>by </small>
          </div>
          {{namaQ}} 
        </span>
        <small class="text-white" style="display:none">Socket Stat : <strong class="text-success">Koneksi Berhasil!!</strong></small>
      </div>
      <div class="sidebar-wrapper mobile" style="background-color:#2c3e50;">
        <ul class="nav user-select-none" style="margin-bottom:30px">
          <li class="nav-item" v-bind:class="{'active' : tabActive === 1}" >
            <router-link class="nav-link" :to="{ name: 'Dashboard'}" v-on:click.native="title('Dashboard'), tabActive = 1, navOpen = !navOpen"><i class="material-icons">dashboard</i> Dashboard</router-link>
          </li>
          <li class="nav-item" >
            <a class="pt-2 pb-2 d-block text-white mt-2 h3 pointer" @click="boxPelanggan = !boxPelanggan"> 
              <i class="material-icons text-info" style="float:none;">account_box</i> <strong class="text-info">MANAG. PELANGGAN</strong>
            </a>
          </li>
          <div class="pl-3" v-show="boxPelanggan"> <!-- PELANGGAN -->
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'pelanggan'}" >
              <router-link class="nav-link" :to="{ name: 'pelanggan'}" v-on:click.native="title('pelanggan'), tabActive = 'pelanggan', navOpen = !navOpen">
                <i class="material-icons">account_box</i> Pelanggan <span class="badge badge-warning ml-2">{{belum}}</span>
              </router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'wa'}" >
              <router-link class="nav-link" :to="{ name: 'wa'}" v-on:click.native="title('wa'), tabActive = 'wa', navOpen = !navOpen"><i class="material-icons">chat</i> WhatsApp BOT</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'mikrotik'}" >
              <router-link class="nav-link" :to="{ name: 'mikrotik'}" v-on:click.native="title('mikrotik'), tabActive = 'mikrotik', navOpen = !navOpen"><i class="material-icons">settings_input_composite</i> My Mikrotik</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'export'}" >
              <router-link class="nav-link" :to="{ name: 'export'}" v-on:click.native="title('export'), tabActive = 'export', navOpen = !navOpen"><i class="material-icons">upgrade</i> EXPORT</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'pelanggan-singkron'}" >
              <router-link class="nav-link" :to="{ name: 'pelanggan-singkron'}" v-on:click.native="title('pelanggan-singkron'), tabActive = 'pelanggan-singkron', navOpen = !navOpen"><i class="material-icons">dns</i> Cek Singkron Mikrotik</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'cek-ppoe'}" >
              <router-link class="nav-link" :to="{ name: 'cek-ppoe'}" v-on:click.native="title('cek-ppoe'), tabActive = 'cek-ppoe', navOpen = !navOpen"><i class="material-icons">dns</i> Cek PPOE</router-link>
            </li>
          </div>
          <li class="nav-item" >
            <a class="pt-2 pb-2 d-block text-white mt-2 h3 pointer" @click="boxKaryawan = !boxKaryawan"> 
              <i class="material-icons text-info" style="float:none;">list</i> <strong class="text-info">MANAG. KARYAWAN</strong>
            </a>
          </li>
          <div class="pl-3" v-show="boxKaryawan"> <!-- KARYAWAN -->

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'tugas'}" >
              <router-link class="nav-link" :to="{ name: 'tugas'}" v-on:click.native="title('tugas'), tabActive = 'tugas', navOpen = !navOpen"><i class="material-icons">person</i> Tugas Teknisi <span class="badge badge-warning ml-2">{{totalTugas}}</span></router-link>
            </li>

            <li v-show="tipe != null" class="nav-item" v-bind:class="{'active' : tabActive === 'absensi'}" >
              <router-link class="nav-link" :to="{ name: 'absensi'}" v-on:click.native="title('absensi'), tabActive = 'absensi', navOpen = !navOpen"><i class="material-icons">list</i> ABSENSI <span class="badge badge-success ml-1">{{totalAbsensi}}</span></router-link>
            </li>
            
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'admin-beranda'}" >
              <router-link class="nav-link" :to="{ name: 'admin-beranda'}" v-on:click.native="title('admin-beranda'), tabActive = 'admin-beranda', navOpen = !navOpen"><i class="material-icons">person</i> Admin</router-link>
            </li>

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'absensi-karyawan'}" >
              <router-link class="nav-link" :to="{ name: 'absensi-karyawan'}" v-on:click.native="title('absensi-karyawan'), tabActive = 'absensi-karyawan', navOpen = !navOpen"><i class="material-icons">person</i> Karyawan</router-link>
            </li>

          </div>

          <li class="nav-item" >
            <a class="pt-2 pb-2 d-block text-white mt-2 h3 pointer" @click="boxPembukuan = !boxPembukuan"> 
              <i class="material-icons text-info" style="float:none;">article</i> <strong class="text-info">MANAG. PEMBUKUAN</strong>
            </a>
          </li>
          <div class="pl-3" v-show="boxPembukuan"> <!-- PEMBUKUAN -->

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'pembukuan'}" >
              <router-link class="nav-link" :to="{ name: 'pembukuan'}" v-on:click.native="title('pembukuan'), tabActive = 'pembukuan', navOpen = !navOpen"><i class="material-icons">article</i> Pembukuan</router-link>
            </li>

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'pembukuan-sisa'}" >
              <router-link class="nav-link" :to="{ name: 'pembukuan-sisa'}" v-on:click.native="title('pembukuan-sisa'), tabActive = 'pembukuan-sisa', navOpen = !navOpen"><i class="material-icons">people</i> Pembukuan Kang Tagih</router-link>
            </li>

          </div>

          <li class="nav-item" >
            <a class="pt-2 pb-2 d-block text-white mt-2 h3 pointer" @click="boxLain = !boxLain"> 
              <i class="material-icons text-info" style="float:none;">settings</i> <strong class="text-info">LAIN LAIN</strong>
            </a>
          </li>
          <div class="pl-3" v-show="boxLain"> <!-- LAIN LAIN BOX -->

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'logact'}" >
              <router-link class="nav-link" :to="{ name: 'logact'}" v-on:click.native="title('logact'), tabActive = 'logact', navOpen = !navOpen"><i class="material-icons">list</i> LOG ACT</router-link>
            </li>
            <li v-show="tipe != null" class="nav-item" v-bind:class="{'active' : tabActive === 'odcodp'}" >
              <router-link class="nav-link" :to="{ name: 'odcodp'}" v-on:click.native="title('odcodp'), tabActive = 'odcodp', navOpen = !navOpen"><i class="material-icons">device_hub</i> ODC & ODP</router-link>
            </li>
            <li v-show="tipe != null" class="nav-item" v-bind:class="{'active' : tabActive === 'map'}" >
              <router-link class="nav-link" :to="{ name: 'map'}" v-on:click.native="title('map'), tabActive = 'map', navOpen = !navOpen"><i class="material-icons ">map</i> Map</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'network'}" >
              <router-link class="nav-link" :to="{ name: 'network'}" v-on:click.native="title('network'), tabActive = 'network', navOpen = !navOpen"><i class="material-icons">alt_route</i> Network</router-link>
            </li>
            <li class="nav-item" v-bind:class="{'active' : tabActive === 'voucher'}" >
              <router-link class="nav-link" :to="{ name: 'voucher'}" v-on:click.native="title('voucher'), tabActive = 'voucher', navOpen = !navOpen"><i class="material-icons">app_shortcut</i> Voucher</router-link>
            </li>
            
          </div>

          <li class="nav-item" >
            <a class="pt-2 pb-2 d-block  mt-2 h3 pointer" @click="boxMitra = !boxMitra"> 
              <i class="material-icons text-info" style="float:none;">settings</i> <strong class="text-info">MITRA</strong>
            </a>
          </li>

          <div class="pl-3" v-show="boxMitra"> <!-- LAIN LAIN BOX -->


            <li class="nav-item" v-bind:class="{'active' : tabActive === 'mitra'}"  v-show="tipe != null">
              <router-link class="nav-link" :to="{ name: 'mitra'}" v-on:click.native="title('mitra'), tabActive = 'mitra', navOpen = !navOpen"><i class="material-icons">person</i> Data Mitra</router-link>
            </li>

            <li class="nav-item" v-bind:class="{'active' : tabActive === 'areamitra'}"  v-show="tipe != null">
              <router-link class="nav-link" :to="{ name: 'mitra-area'}" v-on:click.native="title('areamitra'), tabActive = 'areamitra', navOpen = !navOpen"><i class="material-icons">person</i> Area Mitra</router-link>
            </li>


            <li class="nav-item" v-bind:class="{'active' : tabActive === 'mitra-history'}"  v-show="tipe != null">
              <router-link class="nav-link" :to="{ name: 'mitra-history'}" v-on:click.native="title('mitra-history'), tabActive = 'mitra-history', navOpen = !navOpen"><i class="material-icons">person</i> History Bayar Mitra</router-link>
            </li>

          </div>

          <!--
          <li v-if="RootOnly()" class="nav-item" v-bind:class="{'active' : tabActive === 'setting'}" >
            <router-link class="nav-link" :to="{ name: 'paket'}" v-on:click.native="title('setting'), tabActive = 'setting', navOpen = !navOpen"><i class="material-icons">settings</i> Setting / Profil Ku</router-link>
          </li>
          -->
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'belum'}" v-show="false" >
            <router-link class="nav-link" :to="{ name: 'belum'}" v-on:click.native="title('belum'), tabActive = 'belum', navOpen = !navOpen"><i class="material-icons">account_box</i> Belum Bayar</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'lunas'}"  v-show="false" >
            <router-link class="nav-link" :to="{ name: 'lunas'}" v-on:click.native="title('lunas'), tabActive = 'lunas', navOpen = !navOpen"><i class="material-icons">list</i> History Pembayaran</router-link>
          </li>
          <li v-show="false" class="nav-item" v-bind:class="{'active' : tabActive === 'area'}" >
            <router-link class="nav-link" :to="{ name: 'area'}" v-on:click.native="title('area'), tabActive = 'area', navOpen = !navOpen"><i class="material-icons"><span class="material-icons">crop_square</span></i> Area</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'tarifvoucher'}"  v-show="false">
            <router-link class="nav-link" :to="{ name: 'tarifvoucher'}" v-on:click.native="title('tarifvoucher'), tabActive = 'tarifvoucher', navOpen = !navOpen"><i class="material-icons">emoji_food_beverage</i> Tarif Voucher</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'pengeluaran'}" v-show="false">
            <router-link class="nav-link" :to="{ name: 'pengeluaran'}" v-on:click.native="title('pengeluaran'), tabActive = 'pengeluaran', navOpen = !navOpen"><i class="material-icons">article</i> Pengeluaran</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'forum'}" v-show="false">
            <router-link class="nav-link" :to="{ name: 'forum'}" v-on:click.native="title('forum'), tabActive = 'forum', navOpen = !navOpen"><i class="material-icons">forum</i> Forum</router-link>
          </li>


          <!--

          <li class="nav-item" v-bind:class="{'active' : tabActive === 'tugas'}" >
            <router-link class="nav-link" :to="{ name: 'tugas'}" v-on:click.native="title('tugas'), tabActive = 'tugas', navOpen = !navOpen"><i class="material-icons">person</i> Tugas Teknisi</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'admin'}" >
            <router-link class="nav-link" :to="{ name: 'admin'}" v-on:click.native="title('admin'), tabActive = 'admin', navOpen = !navOpen"><i class="material-icons">person</i> Kang Tagih</router-link>
          </li>
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'teknisi'}" >
            <router-link class="nav-link" :to="{ name: 'teknisi'}" v-on:click.native="title('teknisi'), tabActive = 'teknisi', navOpen = !navOpen"><i class="material-icons">person</i> Kang Teknisi</router-link>
          </li>

          <li class="nav-item" v-bind:class="{'active' : tabActive === 'kang-voucher'}">
            <router-link class="nav-link" :to="{ name: 'kang-voucher'}" v-on:click.native="title('kang-voucher'), tabActive = 'kang-voucher', navOpen = !navOpen"><i class="material-icons">person</i> Kang Voucher</router-link>
          </li>
          -->

          <!--
          <li v-if="RootOnly()" class="nav-item" v-bind:class="{'active' : tabActive === 'perusahaan'}"  v-show="tipe != null">
            <router-link class="nav-link" :to="{ name: 'perusahaan'}" v-on:click.native="title('perusahaan'), tabActive = 'perusahaan', navOpen = !navOpen"><i class="material-icons">settings</i> Setting Perusahaan</router-link>
          </li>
          -->



          <li class="nav-item" v-bind:class="{'active' : tabActive === 'laporan'}" v-show="false">
            <router-link class="nav-link" :to="{ name: 'laporan'}" v-on:click.native="title('laporan'), tabActive = 'laporan', navOpen = !navOpen"><i class="material-icons">person</i> Laporan Pelanggan</router-link>
          </li>

          <li class="nav-item" v-bind:class="{'active' : tabActive === 'log'}" v-show="false" >
            <router-link class="nav-link" :to="{ name: 'log'}" v-on:click.native="title('log'), tabActive = 'log', navOpen = !navOpen"><i class="material-icons">info</i> Log Develope</router-link>
          </li>

          <li class="nav-item" v-bind:class="{'active' : tabActive === 'log'}" style="opacity:0">
            <router-link class="nav-link" :to="{ name: 'log'}" v-on:click.native="title('log'), tabActive = 'log', navOpen = !navOpen"><i class="material-icons">info</i> Log Develope</router-link>
          </li>
          <!--
          <li class="nav-item" v-bind:class="{'active' : tabActive === 'tarif'}" >
            <router-link class="nav-link" :to="{ name: 'tarif'}" v-on:click.native="title('tarif'), tabActive = 'tarif', navOpen = !navOpen"><i class="material-icons">eco</i> Tarif</router-link>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="main-panel" v-bind:class="{'mobile-panel' : navOpen}">
      <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top " v-show="loginStat">
        <div class="container-fluid">
          <div class="navbar-wrapper"  style="width:100%">
            <div class="d-flex box-horizontal ml-3 mb-0 mt-3 mr-3"  style="width:100%">
              <div class="flex-1 d-inline" @click="menuPopup = false">
                <span class="box-horizontal mb-0">
                  Bulan Default :&nbsp;
                  <strong class="text-primary bulan-def-btn" @click="modalBulan = true"> {{bulanBaseName}} &nbsp;</strong> 
                  <span><strong class="text-primary bulan-def-btn" @click="modalTahun = true"> {{tahunBase}}</strong> </span>
                  <i class="material-icons text-info ml-2 pointer" @click="modalInfo = true">error</i>
                </span>
              </div>
              <div class="box-horizontal mb-0 mr-4">
                <input type="text" class="form-control" placeholder="Cari Cepat..." v-model="cariCepatVal">
                <button class="btn btn-sm btn-info" @click="cariCepat()">Cari</button>
              </div>
              <div class="box-horizontal mb-0">
                <span >{{nickToko}} Admin <strong class="text-primary"> {{Versi}}</strong></span>
                <i class="material-icons text-info pl-3 cursor-pointer" @click="menuPopup = true">settings</i>
              </div>
              <div v-show="menuPopup" class="mr-5 position-absolute pt-2" style="right:0;background-color:#fff;margin-top:150px">
                <small class="text-secondary ml-4">Setting</small>
                <div class="list-group">
                  <router-link :to="{ name: 'paket'}" v-if="RootOnly()" @click.native="menuPopup = false" class="list-group-item  list-group-item-action d-flex align-items-center" style="color:#333 !important;">
                    <i class="material-icons text-secondary mr-1">person</i> Profil
                  </router-link>
                  <router-link :to="{ name: 'perusahaan'}" v-if="RootOnly()" @click.native="menuPopup = false" class="list-group-item list-group-item-action d-flex align-items-center" style="color:#333 !important;">
                    <i class="material-icons text-secondary mr-1">settings</i> Perusahaan
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" v-on:click="navOpen = !navOpen">
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-end">
            <div v-show="false" class=" theTombol mr-5" @click="download()">
              <div class="box-horizontal" style="margin-bottom:0">
                <strong class="text-info">Server WA Bot :&nbsp;</strong>
                <div>
                  <strong v-if="server" class="text-success">Online</strong>
                  <strong v-else class="text-danger">Offline</strong>
                </div>
              </div>
              <small>Jika offline hubungi admin ya</small>
            </div>
          </div>
        </div>
      </nav>

      <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
      </transition>

    </div>
    


      <!-- MODAL INFO -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalInfo">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">

					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">INFO</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalInfo = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
                <p><strong>BULAN DEFAULT </strong>adalah fitur untuk menentukan bulan berapa kita ingin mengolah data. Mis : Desember, jadi semua data default akan muncul pada bulan desember saja.</p>
						</div>
					</div>
				</div>
			</div>

      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalBulan">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Bulan</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalBulan = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height: 500px;overflow:auto;">
                    <table class="table">
                      <thead class=" text-info">
                        <th>Bulan</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in bulan">
                          <td>{{ u.nama }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihBulan(u.id,u.nama),modalBulan = false"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalTahun">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Tahun</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalTahun = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height: 500px;overflow:auto;">
                    <table class="table">
                      <thead class=" text-info">
                        <th>Bulan</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>2025</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihTahun('2025'),modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2026</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihTahun('2026'),modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2027</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihTahun('2027'),modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2028</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihTahun('2028'),modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2029</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihTahun('2029'),modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>

      <div class="item-chat box-horizontal" style="">
        <div class="chat-box" v-for="(u, index) in chatActive">
          <div class="chat-header box-horizontal">
            <small class="flex-1" >{{u.content.name}} {{"("+u.content.telepon+")"}}</small>
            <i class="tutup-chat material-icons" @click="deleteChat(u.content.telepon)">close</i>
          </div>
          <div class="chat-content" :ref="`scroll-`+u.content.telepon">
            <!-- <div  -->
            <div class="chat-list">
              <div class="chat-info">
                Kami tidak pernah membaca chat anda sebelumnya. Sesi akan selalu baru ketika anda membuka chat
              </div>
              <div class="chat-item" v-for="(x, indexx) in u.content.chat">
                <div class="chat-bub">
                  <div class="chat-left" v-bind:class="{'chat-right ' : x.position === 'right'}">
                    {{x.teks}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-footer">
            <div class="box-horizontal">
              <small class="quick-chat" @click="kirimWA(u.content.user,u.header)">Tagihan</small>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Ketik disini..." :ref="u.content.telepon" @keyup.enter="kirimChat(u.content.telepon,u.content.name)">
              <button class="btn btn-sm btn-outline-info" @click="kirimChat(u.content.telepon,u.content.name)">Kirim</button>
            </div>
          </div>
        </div>
      </div>

      
			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="modalWABlast">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalWABlast = false">
                <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row" style="margin-left:-15px;margin-right:-15px;width:auto">
                  <div class="col-md-12">
                    <div class="form-group">
                        <div class="form-group">
                          <label class="bmd-label-floating">Ketikan Teks yang akan di kirim</label>
                          <textarea rows="10" type="text" class="form-control" placeholder="Ketik disini..." v-model="wa"></textarea>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="modalWABlast = false,testTextToURL()">Kirim</button>
              </div>
          </div>
        </div>
      </div>
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalWA">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Progress WA</h5>
						</div>
						<div class="modal-body">
              <div class="text-center">
                <p class="text-info">{{pesanKirimPause}}</p>
                <h2 class="mb-0">{{progress}} / <small><small>{{totalProgress}}</small></small></h2>
                <p>{{pesanKirim}}</p>
                
                <p class="text-warning">Jangan tutup Popup Ini, untuk melihat progress pengiriman pesan</p>
              </div>
						</div>
						<div class="modal-footer" v-show="modalWAFooter">
              <button class="btn btn-success" @click="modalWA = false"> Tutup</button>
					  </div>
					</div>
				</div>
			</div>  

      <div id="loading-box" v-show="loadingBox">
        <div class="l-inner text-center">
          <img class="icon-logo" src="@/assets/logo.png" alt="">
          <h3>Sedang mengambil data...</h3>
        </div>
      </div>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url,homePage,tNama,tAlamat,tAlamatAncer2,tWA,tNick,Versi,urlSocket,conlog } from '@/var/var.js'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import interAbsen from '@/globalFunc/InterfaceAbsensi' 

Vue.use(require('vue-shortkey'))

export default {
  name: 'App',
  sockets: {
    connection: function(){
      console.log('socket connected')
      this.server = true;
    },
    message: function(val){
      console.log(JSON.stringify(val))

      
    },
    chatin: function(val) {
      var d = val;
      var telp = d.from.replace(/@c.us/g, "");;
      var teks = d.body;
      var first = telp.charAt(0);
      if (first == "0") {
        telp = telp.substring(1);
        
        //console.log(telp);
      }
      if (first == "6") {
        telp = telp.substring(2);
        
        //console.log(telp);
      }

      this.terimaChat(telp,teks);

    },
    sent: function(val) {
      //console.log(val)
      
      if(val == "sukses") {
        this.pesanKirimPause = "Pesan berhasil Dikirim";
        this.modalWAFooter = true;
        this.modalWAPasswordFooter = true;
        this.cekWA = false;
        this.checkedNames = [];
        this.selectWaBlast = false;
      } else if (val == "start") {
        this.pesanKirimPause = "Mulai Mengirim Pesan..";
      } else if (val == "restart") {
        this.pesanKirimPause = "Lanjoet Mengirim Pesan...";
      } else if (val == "pause") {
        this.pesanKirimPause = "Di Pause 15s, biar ga ke blokir akak No WhatsAppnya";
      } else {
        this.pesanKirim = val;
        this.progress = this.progress + 1;
      }
    }
  },
  data() {
    return {
      nickToko: tNick,
      Versi: Versi,
      namaQ: '',
      bulanBaseName: '',

      modalInfo: false,

      belum: 0,

      boxPelanggan: false,
      boxKaryawan: false, 
      boxPembukuan: false, 
      boxLain: false, 
      boxMitra: false, 


      admin: [],
      tabActive: 1,
      user: '',
      showing: -1,
      hapusDiv: true,
      notif: false,
      loginStat: false, //sessionStorage.getItem('myToken') 
      navOpen: false,

      cariVal: '',

      bulan : [],
      modalBulan: '',

      modalTahun: false,
      tahunBase: '',

      isExpired: false,
      logo: null,

      server: false, // status server

      waBotReady: null,

      pelanggan: [],
      chatActive: [],
      newChat: false,

      bulanBase: '',
      cariChat: '',

      panelSelectWaBlast: false,
      checkedNames: [],
      progress: 0,
      totalProgress: 0,
      modalWABlast: false,
      wa: '',
      pesanKirim: '',
      pesanKirimPause: '',
      modalWAFooter: false,
      modalWA: false,

      tipe: null,
      isCS: false,
      CSNama: null,
      CSId: null,
      cariCepatVal: null,

      menuPopup: false,

      totalTugas: 0,
      totalAbsensi: 0,

      loadingBox: true,
    } 
  },
  watch: {
    $route (to, from){
      if(from.name == "wa") {
        if (sessionStorage.getItem('walogin') != "new") {
          this.$socket.emit('destroy', "okelah bro");
        }
      }
    }
  },
  methods: {
    cariCepat() {
      // location.href="#/cari-cepat"
      
      this.$router.push({ 
        name: 'cari-cepat', 
          params: {
            cari: this.cariCepatVal
          } 
        });

        this.cariCepatVal = null  
    },  
    title (teks) {
      //this.$title.text = teks
      return
    },
    pilihBulan(id,nama) {
      sessionStorage.setItem('bulanIdBase', id);
      sessionStorage.setItem('bulanNamaBase', nama);

      this.bulanBaseName = nama;
    },
    pilihTahun(angka) {
      sessionStorage.setItem('tahunBase', angka);
      this.tahunBase = sessionStorage.getItem('tahunBase');
    },
    download() {
      window.open('https://play.google.com/store/apps/details?id=com.rtrw.myuser','_blank');
    },
    getDataB() {

      console.log("sidemenu");

      var datax = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        bulan: myGlobal.getBulan(),
        tahun: myGlobal.getTahunNow() 
      }
      
      var apiUrl = 'beranda';
      
      myGlobal.call(datax,apiUrl).then(x => {
        //console.log(JSON.stringify(x));

        if (x.status == true) {
          var sisa = x.data.sisa;
          if (sisa < 0) {
            alert("expired bos, Hubungi admin ya :)");
            this.isExpired = true;
						location.href = '#/';
          }

          this.logo = x.data.logo;
          sessionStorage.setItem('logo', x.data.logo);
          
          this.belum = x.data.belum;

          // bayar online ==================================================================================================
          // null == terima, tidak
          var bayarOnlinex = "terima";
          if (x.data.bayarOnline == "tidak") {
            bayarOnlinex = "tidak";
          }
          sessionStorage.setItem('bayarOnline', bayarOnlinex);
          // bayar online END ==============================================================================================

          /*
          sessionStorage.setItem('myInfoPrint', x.data.info);
          sessionStorage.setItem('infoTeks', x.data.info);
          sessionStorage.setItem('wateks', x.data.wa);
          sessionStorage.setItem('supportby', x.data.support);
           */
          
          sessionStorage.setItem('id', x.data.myID);
          sessionStorage.setItem("beranda-data", JSON.stringify(x));

          // alert(x.data.myID);
          
          /*
          if (x.data.watoken == "login") {
            console.log("resuming wa bot...");
            this.waBotReady = false
            var theData = { 
              id: x.data.myID,
              stat: "resume"
            }
            this.$socket.emit('cek-koneksi', "okelah");
            
            sessionStorage.setItem('walogin', "kosong");
          } else {
            sessionStorage.setItem('walogin', "kosong");
          }

          */

          let dis = this; 
          setTimeout(
            function() {
              dis.hideLoadingBox();
            }
          , 1000);


          this.AmbilJumlahTugas();
          this.AmbilJumlahAbsen();
        }
      })
    },
    
    hideLoadingBox() {
      this.loadingBox = false;
    },

    ChatGetPelanggan() {
      //console.log(this.tglIndo(new Date));
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', "0");
      data.append('tahun', myGlobal.getTahunNow());
      if (this.$route.params.filter == "new") {
        data.append('filter', "new");

        console.log("ini pelanggan baru");
      }

      //alert(this.$route.params.filter);
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));

        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },
    terimaChat(telp,teks) {      
      var d = this.chatActive;
      for (var i = 0; i < d.length; i++) {
        if (d[i].header.indexOf(telp) >= 0) {
          //d.splice(i, 1);

          var chate = {
              position: "left",
              teks: teks
            }

          d[i].content.chat.push(chate);

          var container = this.$refs['scroll-'+d[i].header][0];          
          container.scrollTop = container.scrollHeight;
        }
      }
    },
    AmbilJumlahTugas() {
			var datax = {
				token: 'TangTung '+sessionStorage.getItem('myToken')
			}

      var apiUrl = inter.TugasJumlah();
			this.PostData(datax,apiUrl).then(x => {
				//this.loger(x);

        if(x.status) {
          let datae = x.data;
          this.totalTugas = datae;
        }
			})

    },
    AmbilJumlahAbsen() {
      if(sessionStorage.getItem('myTokenAbsensi') == null) {
        //loginDulu();
        this.loginNow();
        return;
      }

      var datax = {
        token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi')
      };
      var apiUrl = interAbsen.AbsenNow();

      myGlobal.callAbsensi(datax,apiUrl).then(x => {
        
        //myGlobal.loger(x);

        //data.loading = false;

        if (x.status == true) {
          let datae = x.data;
          this.totalAbsensi = datae.sudah;
          
        } else {

          //theGet.data.List = null;

        }

      })
    },
    loginNow() {
      var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
      };
  
      var apiUrl = interAbsen.login();
      myGlobal.callAbsensi(datax,apiUrl).then(x => {
      
          //myGlobal.loger(x);

          if (!x.status == true) {

              //data.baru = true;

            
          
          } else {

            //theGet.data.List = null;

            this.loginSubmit();

          }
          
          // data.loadingBox = false;

          // data.loading = false;

          /*

          */
      })
    },
    loginSubmit() {
      var datax = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        nama: sessionStorage.getItem('admin')
      };
  
      var apiUrl = interAbsen.loginSubmit();
      myGlobal.callAbsensi(datax,apiUrl).then(x => {
        //myGlobal.loger(x);

        if (x.status == true) {
        //data.baru = true;
          sessionStorage.setItem('myTokenAbsensi', x.data);

          this.AmbilJumlahAbsen();

          //data.modalCekSingkron = false;

        //theGet.dataeNow();
        
        } else {
        //theGet.data.List = null;
          //alert(x.pesan)
        }
          
      })
    },
    kirimChat(telp,nama) {
      if (this.$refs[telp][0].value == '') {
        return false;
      }
      
      var d = this.chatActive;
      for (var i = 0; i < d.length; i++) {
        if (d[i].header.indexOf(telp) >= 0) {
          //d.splice(i, 1);

          var teks = this.$refs[telp][0].value;
          var chate = {
              position: "right",
              teks: teks
            }
  
          if (sessionStorage.getItem('walogin') == 'kosong') {
            alert('Anda belum scan wa');
            return false;
          }
          if (sessionStorage.getItem('walogin') == 'belum') {
            alert('Anda belum scan wa');
            return false;
          }
          
          var theData = {
            data: JSON.stringify({
                data: [
                  {
                    unama: nama,
                    wa: telp
                  }
                ],
                pesan: "Bebas sih ini",
                status: true
            }),
            token: this.sesi,
            pesanwa: teks,
            //bulan: this.bulanBase+ ' ' + this.tahunBase,
            //namaKu: sessionStorage.getItem('admin'),
            //wateks: sessionStorage.getItem('wateks'),
            //ppn: sessionStorage.getItem('PPN')
          }
          //console.log(JSON.stringify(theData));

          d[i].content.chat.push(chate);

          this.$socket.emit('kirim-blast-notemplate', theData);

          this.$refs[telp][0].value = "";

          var container = this.$refs['scroll-'+telp][0];          
          container.scrollTop = container.scrollHeight;
        }
      }
      /*

      setTimeout(
        function() {
          var container = this.$refs['scroll-'+telp][0];          
          container.scrollTop = container.scrollHeight;
        }
      , 200);

      */
    },
    deleteChat(telp) {
        var d = this.chatActive;
        for (var i = 0; i < d.length; i++) {
          if (d[i].header.indexOf(telp) >= 0) {
            d.splice(i, 1);
          }
        }
    },
    addChat(id,nama,telp,d) {
      if (this.chatActive.length == 0) {
        var data = [{
          header: telp, // uniq 
          content: {
            name: nama,
            telepon: telp,
            user: d,
            chat: [
              /*
              {
                position: "left",
                teks: "ulala"
              },
              {
                position: "right",
                teks: "ulala"
              },
              {
                position: "left",
                teks: "ulala"
              }
              */
            ] 
            /*
              position: // kiri = pelanggan, kanan = dari owner
              teks: "ulala"
            */
          }
        }]
        this.chatActive = data;

      } else {
        var d = this.chatActive;
        for (var i = 0; i < d.length; i++) {
          if (d[i].header.indexOf(telp) >= 0) {
            return false;
          }
        }
        
        var data = {
          header: telp, // uniq 
          content: {
            name: nama,
            telepon: telp,
            chat: [] 
            /*
              position: // kiri = pelanggan, kanan = dari owner
              teks: "ulala"
            */
          }
        }
        this.chatActive.push(data);

      }
      //console.log(JSON.stringify(this.chatActive));
      
    },
    kirimWA(d,header) {
      if (sessionStorage.getItem('walogin') == 'kosong') {
        alert('Anda belum scan wa');
        return false;
      }
      if (sessionStorage.getItem('walogin') == 'belum') {
        alert('Anda belum scan wa');
        return false;
      }

      //this.progress = 0;

      //this.modalWA = true;

      //this.totalProgress = this.checkedNames.length;

      var theData = {
        data: JSON.stringify({
            data: [d],
            pesan: "Bebas sih ini",
            status: true
        }),
        token: this.sesi,
        bulan: this.bulanBase+ ' ' + this.tahunBase,
        namaKu: sessionStorage.getItem('admin'),
        wateks: sessionStorage.getItem('wateks'),
        ppn: sessionStorage.getItem('PPN')
      }
      //console.log(JSON.stringify(theData));

      this.$socket.emit('kirim-blast', theData);
        
      var d = this.chatActive;
      for (var i = 0; i < d.length; i++) {
        if (d[i].header.indexOf(header) >= 0) {
          //d.splice(i, 1);

          var chate = {
              position: "right",
              teks: "- Tagihan telah dikirim -"
            }

          d[i].content.chat.push(chate);

          var container = this.$refs['scroll-'+d[i].header][0];          
          container.scrollTop = container.scrollHeight;
        }
      }
    },
    cariTeleponApi() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.cariChat);
      data.append('bulan', "0");
      data.append('type', "all");
      data.append('by', "nama");
      //data.append('area', null);
      //data.append('tanggal', null);
      //data.append('admin', null); // JIKA NULL GA USAH DIKIRIM
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        
        if (x.status == true) {
          this.pelanggan = x.data;

        } else {
          //alert(x.pesan);
        }
      })
    },
    handleBeforeUnload(event) {
      // Standar browser untuk memicu dialog konfirmasi


      event.preventDefault();

      event.returnValue = ''; 

      sessionStorage.clear();
    }
  },
  mounted () {

    if(sessionStorage.getItem("myToken") == null) {
      location.href = '#/';
    }

    this.getDataB();
    
    if (sessionStorage.getItem('subAdminID') != 0) {
      this.isCS = true;
      this.CSNama = sessionStorage.getItem('subAdmin'); 
      this.CSId = sessionStorage.getItem('subAdminID');
    }
    this.namaQ = sessionStorage.getItem('admin');
    this.bulanBaseName = sessionStorage.getItem('bulanNamaBase');
    if (sessionStorage.getItem('tahunBase') == null) {
      var d = new Date();
      var n = d.getFullYear();
      this.tahunBase = n; 
      
      sessionStorage.setItem('tahunBase', this.tahunBase);
    } else {
      this.tahunBase = sessionStorage.getItem('tahunBase');
    }

    this.bulan = [
      {
        "id": "01",
        "nama": "Januari"
      },
      {
        "id": "02",
        "nama": "Februari"
      },
      {
        "id": "03",
        "nama": "Maret"
      },
      {
        "id": "04",
        "nama": "April"
      },
      {
        "id": "05",
        "nama": "Mei"
      },
      {
        "id": "06",
        "nama": "Juni"
      },
      {
        "id": "07",
        "nama": "Juli"
      },
      {
        "id": "08",
        "nama": "Agustus"
      },
      {
        "id": "09",
        "nama": "September"
      },
      {
        "id": "10",
        "nama": "Oktober"
      },
      {
        "id": "11",
        "nama": "November"
      },
      {
        "id": "12",
        "nama": "Desember"
      }
    ];

    this.ChatGetPelanggan();

    var bulanNow = this.getBulanNow();
    this.bulanBase = bulanNow;
    this.tahunBase = this.getTahunNow();
    
    if (sessionStorage.getItem('myToken') === null) {
      this.loginStat = false
      location.href="#"
    } else {
      this.loginStat = true 
    }

    if (sessionStorage.getItem('tipe') != null) {
      this.tipe = sessionStorage.getItem('tipe');
    }
      
    if (!conlog) {
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

  }
}
</script>

<style scoped>

.mobile {
  transform: translate3d(0px, 0, 0) !important;
}
.mobile-panel {
  /*transform: translate3d(-260px, 0, 0) !important;*/
}
a {
  color: #fff !important;
}
.row {
  margin-left: 5%;
  width: 90%;
}
.cari-sidebar {
  width: 75%;
  height: 40px;
  line-height: 40px !important;
}
.btn-sidebar {
  height: 40px;
  width: 40px;
  border-radius: 40px;
  border:none;
  margin-left: 10px;
  background-color: #1abc9c;
  text-align: center;
}
.btn-sidebar > i {
  color: #fff !important;
  text-align: center;
  margin-right: 0;
  margin-left: 5px;
  line-height: 40px !important;
}
.toko-title {
  color: #fff;
  text-align: center;
  width: 100%;
  background-color: #e30083;
  padding-top: 10px;
  padding-bottom: 10px;
}
.nav-link {
  padding: 5px 15px !important;
  display: flex;
  align-items: center;
}

.bulan-def-btn {
  cursor: pointer;
}

.modal {
	display: inherit;
}

.theTombol {
  cursor: pointer;
}

.panel-wa-bot {
  position: fixed;
  z-index: 99999;
  right: 0;
  bottom: 0;
  top: 0;
}
.panel-kanan, .p-inner {
  width: 275px;
  background: #fff;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
}
.p-inner {
  display: flex;
  flex-direction: column;
}
.tombol-open {
  position: absolute;
  top: 0;
  -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
  background: #00acc1;
  margin-top: 30px;
  width: 100px;
  padding: 10px 20px;
  margin-left: -70px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.p-header {
  padding: 15px 20px;
  background: #00acc1;
  color: #fff;
}
.p-content {
  padding: 10px;
  overflow: auto;
  flex:1;
}


.item-chat {
  position: fixed;
  bottom: 0;
  right: 275px;
  z-index: 999;
  margin-bottom:0 !important;
}
.chat-item {
  cursor: pointer;
}
.chat-item:hover {
  background: #f5f5f5;
}
.chat-box {
  width: 250px;
  background: #fff;
  margin-right: 5px;
}
.chat-header {
  background: #00acc1;
  padding: 10px;
  color: #fff;
  margin: 0 !important;
}
.chat-content {
  height: 300px;
  overflow: auto;
  
}
.chat-list {
  
}
.chat-info {
  background: rgba(52, 152, 219, 0.3);
  padding: 10px;
  border-radius: 10px;
  margin: 10px;
  font-size: 10pt;
  line-height: 1.2;
}
.chat-item {
  padding: 5px 10px;
}
.chat-bub {
  display: flex;
  width: 100%;
}
.chat-left {
  background: #bdc3c7;
  padding: 5px;
  font-size: 10pt;
  border-radius: 5px;
}
.chat-right {
  background: #3498db;
  margin-left: auto;
  padding: 5px;
  border-radius: 5px;
  color:#fff;
}
.chat-footer {
  padding: 5px 10px;
}
.tutup-chat {
  cursor: pointer;
}
.chat-notif {
  position: absolute;
  text-align: center;
  width: 100%;
  margin-top: 10px;
}
.chat-notif > small {
  background: rgba(46, 204, 113,0.9);
  padding: 5px 10px;
  border-radius: 3px;
  color:#fff;
}
.quick-chat {
  background: rgba(46, 204, 113,0.9);
  padding: 5px 10px;
  border-radius: 3px;
  color:#fff;
  font-size: 8pt;
  line-height: 1;
  margin-right: 5px;
  cursor: pointer;
  user-select: none;
}
.modal {
	display: inherit;
}

#loading-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;

}
#loading-box img {
  width: 100px;
  animation: hithere 1s ease infinite;
}
@keyframes hithere {
  30% { transform: scale(1); }
  40%, 60% { transform: rotate(-20deg) scale(1); }
  50% { transform: rotate(20deg) scale(1); }
  70% { transform: rotate(0deg) scale(1); }
  100% { transform: scale(1); }
}

</style>



// WEBPACK FOOTER //
// src/components/Beranda.vue